/**
 * @generated SignedSource<<54d072718aed88dd00a77d243a0cf638>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoWrapper_sku$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedShippingInfoWrapper_sku";
};
export type PdpSharedShippingInfoWrapper_sku$key = {
  readonly " $data"?: PdpSharedShippingInfoWrapper_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoWrapper_sku",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "e48e9bf8f13b2441932e50f7c62943cd";

export default node;
